<template>
  <widget title="Past Due / At Risk">
    <template v-slot:content style="overflow: hidden">
      <div class="centered large count">{{ pastDueAtRisk.count }}</div>
    </template>
  </widget>
</template>

<script>

import store from '@/store'
import Widget from './Widget'

export default {
  name: 'PastDueAtRisk',
  components: {
    Widget
  },
  computed: {
    pastDueAtRisk () {
      return store.state.dashboard.pastDueAtRisk
    }
  },
  beforeMount () {
    store.dispatch('dashboard/fetchPastDueAtRisk')
  }
}
</script>

<style scoped>

</style>
